// import { initializeApp } from "firebase/app";
// import {
//   getMessaging,
//   getToken,
//   onMessage,
//   isSupported,
// } from "firebase/messaging";

// // Firebase configuration object with environment variables
// var firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDERID,
//   appId: process.env.REACT_APP_FIREBASE_APPID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
// };
// (Legacy hardcoded firebaseConfig removed — values now come from REACT_APP_FIREBASE_* env vars.)

// // Initialize Firebase app with the configuration
// const firebaseApp = initializeApp(firebaseConfig);

// // Initialize Firebase messaging
// const messaging = (async () => {
//   try {
//     const isSupportedBrowser = await isSupported();
//     if (isSupportedBrowser) {
//       return getMessaging(firebaseApp);
//     }
//     console.log("Firebase not supported in this browser");
//     return null;
//   } catch (err) {
//     console.log(err);
//     return null;
//   }
// })();

// // Function to fetch the messaging token
// export const fetchToken = async (setTokenFound, setNotificationErr) => {
//   try {
//     const messagingResolve = await messaging;
//     const currentToken = await getToken(messagingResolve, {
//       vapidKey: process.env.REACT_APP_VAPID_KEY,
//     });
//     if (currentToken) {
//       setTokenFound(true);
//       return currentToken;
//     } else {
//       console.log(
//         "No registration token available. Request permission to generate one."
//       );
//       setTokenFound(false);
//       setNotificationErr(true);
//     }
//   } catch (err) {
//     console.log("An error occurred while retrieving token. ", err);
//     setNotificationErr(true);
//   }
// };

// // Function to listen for incoming messages
// export const onMessageListener = async () =>
//   new Promise((resolve) =>
//     (async () => {
//       const messagingResolve = await messaging;
//       onMessage(messagingResolve, (payload) => {
//         console.log("🚀 ~ onMessage ~ payload:", payload);
//         resolve(payload);
//       });
//     })()
//   );

// firebase.js;

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Replace this firebaseConfig object with the congurations for the project you created on your firebase console.
var firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STROAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
// Only initialize Firebase Messaging when the config is actually present.
// In local dev (no REACT_APP_FIREBASE_* vars) this avoids getMessaging()
// throwing at import time and white-screening the whole app.
let messaging = null;
try {
  if (
    firebaseConfig.apiKey &&
    firebaseConfig.projectId &&
    firebaseConfig.messagingSenderId
  ) {
    initializeApp(firebaseConfig);
    messaging = getMessaging();
  } else {
    console.warn(
      "Firebase config missing — push notifications disabled (local dev)."
    );
  }
} catch (err) {
  console.warn(
    "Firebase initialization failed — push notifications disabled.",
    err
  );
}

export const requestForToken = () => {
  if (!messaging) return Promise.resolve();
  return getToken(messaging, {
    vapidKey: process.env.REACT_APP_VAPID_KEY,
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log("current token for client: ", currentToken);
        // Perform any other neccessary action with the token
      } else {
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
};


export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
      console.log("payload", payload);
      resolve(payload);
    });
  });
